import { UseSuspenseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { fetchFilterResource } from 'api/filters';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { filterQueryKeys } from 'queries/filter-query-keys';
import { FilterCampaign } from 'types/domain';
import { GivebutterAxiosError } from 'types/error';

type CampaignSelectResource = 'campaigns' | 'auction-campaigns' | 'event-campaigns';

interface UseCampaignSelectItemsOptions<T>
    extends Omit<
        UseSuspenseQueryOptions<FilterCampaign[], GivebutterAxiosError, T, any>,
        'queryKey'
    > {}

function useCampaignSelectItems<T = FilterCampaign[]>(
    resource: CampaignSelectResource = 'campaigns',
    options?: UseCampaignSelectItemsOptions<T>,
) {
    const { accountId } = useCurrentAccount();

    return useSuspenseQuery({
        queryKey: filterQueryKeys.campaignsWithFilter(accountId, resource),
        queryFn: () => fetchFilterResource<FilterCampaign>(resource)({ accountId }),
        staleTime: Infinity,
        ...options,
    });
}

export { useCampaignSelectItems };
export type { CampaignSelectResource };
